"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apply = void 0;
var react_1 = __importDefault(require("react"));
var button_1 = require("@chakra-ui/button");
var layout_1 = require("@chakra-ui/layout");
var layout_2 = require("../../../common/layout");
var lineLogin_1 = require("../../../common/line/lineLogin");
var ContentLayout_1 = require("../../../common/layout/ContentLayout");
var PageLoading_1 = require("../../../common/loading/PageLoading");
var ApplicationStatus_1 = require("./ApplicationStatus");
var useSetMeta_1 = require("../../../common/hooks/useSetMeta");
var useShop_1 = require("../../../common/hooks/useShop");
var useLineLogin_1 = require("../../../common/line/useLineLogin");
var useLineUser_1 = require("../../../common/hooks/useLineUser");
var useApply_1 = require("./useApply");
var Apply = function () {
    var _a = (0, useLineLogin_1.useLineLogin)(), randomState = _a.randomState, lineInfo = _a.lineInfo;
    var _b = (0, useLineUser_1.useLineUser)(), LineUser = _b.LineUser, LineUserLoading = _b.LineUserLoading;
    var _c = (0, useShop_1.useShop)(), shopData = _c.shopData, isShopLoading = _c.isShopLoading;
    var _d = (0, useApply_1.useApply)(), isPresentLoading = _d.isPresentLoading, isAppliedLoading = _d.isAppliedLoading, isApplied = _d.isApplied, holdingStatus = _d.holdingStatus, contentData = _d.contentData;
    (0, useSetMeta_1.useSetMeta)("プレゼント応募");
    if (isShopLoading ||
        LineUserLoading ||
        isPresentLoading ||
        isAppliedLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    return (react_1.default.createElement(react_1.default.Fragment, null, shopData && (react_1.default.createElement(layout_2.Layout, { headerUrl: shopData.logo_image, isHeader: true, isFooter: true, isLoading: isPresentLoading },
        react_1.default.createElement(layout_1.Container, { maxW: "container.xl", py: "2em" },
            react_1.default.createElement(layout_1.Text, { as: "h2", fontSize: { base: "2.4rem", md: "3.4rem" }, fontWeight: "bold", textAlign: "center" }, "\u30D7\u30EC\u30BC\u30F3\u30C8\u5FDC\u52DF"),
            contentData && (react_1.default.createElement(ContentLayout_1.ContentLayout, { contentBlocksData: contentData })),
            react_1.default.createElement(ApplicationStatus_1.ApplicationStatus, { isApplied: isApplied, holdingStatus: holdingStatus }, LineUser ? (react_1.default.createElement(layout_1.Box, { textAlign: "center", mt: "1rem" },
                react_1.default.createElement(button_1.Button, { as: "a", href: "/main/apply/form", color: "white", bg: "#F9B812", size: "lg", height: "4rem", fontSize: "1.6rem", minW: "10rem", _hover: {
                        color: "white",
                        backgroundColor: "#D59D0F",
                        textDecoration: "none",
                    }, _active: {
                        color: "white",
                        backgroundColor: "#BF8D0D",
                    } }, "\u5FDC\u52DF\u30D5\u30A9\u30FC\u30E0\u3078\u9032\u3080"))) : (react_1.default.createElement(layout_1.Box, { textAlign: "center" },
                react_1.default.createElement(layout_1.Text, { mt: "1rem", fontSize: "1.6rem" }, "\u30D7\u30EC\u30BC\u30F3\u30C8\u5FDC\u52DF\u306FLINE\u304A\u53CB\u3060\u3061\u767B\u9332\u304C\u5FC5\u8981\u3067\u3059\u3002"),
                react_1.default.createElement(lineLogin_1.LineLogin, { redirectUri: lineInfo.baseUrl + "/main/apply/check", randomState: randomState, clienId: lineInfo.lineClientId })))))))));
};
exports.Apply = Apply;
